import { ErrorBoundary as SentryBoundaryLib, ErrorBoundaryProps } from '@sentry/nextjs';

const ErrorBoundary = ({ children, ...otherProps }: ErrorBoundaryProps) => (
  <SentryBoundaryLib {...otherProps}>{children}</SentryBoundaryLib>
);

export default ErrorBoundary;
